import { render, staticRenderFns } from "./Marketplace.vue?vue&type=template&id=ab313f32&"
import script from "./Marketplace.vue?vue&type=script&lang=ts&"
export * from "./Marketplace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports